import React, { useState } from 'react'

const MultiStepWrapper = props => {
  const {
    children,
    totalSteps,
    schema: { formName },
  } = props
  const [activeIndex, setActiveIndex] = useState(parseInt(props.query?.position, 10) || 0)
  const numberOfSections = (totalSteps && totalSteps - 1) || children.length || 0
  const [completionState, setCompletionState] = useState(new Array(totalSteps).fill(false))

  const goToPage = index => {
    if (isNaN(index)) return
    index = Math.max(0, index)
    index = Math.min(index, numberOfSections)
    setActiveIndex(index)
    const scrollOffset = 20
    const formElement = document.querySelector(`form[name=multi-step-${formName}`).children[index]
    const formPosition = formElement.getBoundingClientRect().top
    const offsetPosition = formPosition - scrollOffset + window.scrollY

    window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
  }

  const goToUrl = url => {
    if (url) {
      const { trackEvent } = props

      const trackingObj = {
        tracking: {
          category: { value: 'Site Interaction' },
          action: { value: 'Redirection from form' },
          label: { value: `Redirected to ${url}` },
        },
      }

      trackEvent(trackingObj)

      window.location.href = url
    }
  }

  const goToFirst = () => goToPage(0)
  const goForward = (n = 1) => goToPage(activeIndex + n)
  const goBack = (n = 1) => goToPage(activeIndex - n)
  const goToLast = (n = 1) => goToPage(numberOfSections - n)

  const updateCompletionState = (index, isComplete = true) => {
    completionState[index] = isComplete
    return setCompletionState(completionState)
  }
  // change this to a better name - complete stage concept
  const editFromSummary = () => {
    const { trackEvent } = props
    const trackingObj = {
      tracking: {
        category: { value: 'Site Interaction' },
        action: { value: 'Form step complete' },
        label: { value: activeIndex },
      },
    }

    trackEvent(trackingObj)

    if (completionState[activeIndex + 1]) {
      return goToLast(0)
    }

    return goForward()
  }

  return React.Children.map(props.children, (child, index) => {
    return React.cloneElement(child, {
      ...props,
      goToFirst,
      goForward,
      goBack,
      goToLast,
      goToPage,
      goToUrl,
      index,
      setActiveIndex,
      activeIndex,
      completionState,
      updateCompletionState,
      editFromSummary,
    })
  })
}

export default MultiStepWrapper
